var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "firm-specific-documents loading-content-container" },
    [
      _vm.firmSpecificDocumentsLoading > 0
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _c(
            "b-row",
            { staticClass: "mb-4" },
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    icon: "inticon-autoclaim_document",
                    title: "Firmenspezifische Dokumente",
                  },
                },
                [
                  _vm.permissions.canCreate
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mb-3 right",
                          attrs: { href: _vm.createUrl, variant: "primary" },
                        },
                        [
                          _vm._v(
                            "\n                Dokument erstellen\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clear-float" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "firm-specific-documents-list" },
                    [
                      _vm.tableItems.length
                        ? _c("b-table", {
                            attrs: {
                              fields: _vm.fields,
                              items: _vm.tableItems,
                              responsive: "",
                              striped: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(actions)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "table-actions",
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          data.item.permissions.canShow
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.getFirmSpecificDocumentDetailUrl(
                                                      data.item.id
                                                    ),
                                                    title: "Details anzeigen",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "inticon-autoclaim_detail",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          data.item.permissions.canEdit
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.getFirmSpecificDocumentEditUrl(
                                                      data.item.id
                                                    ),
                                                    title: "Bearbeiten",
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "inticon-autoclaim_bearbeiten",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          data.item.permissions.canDelete
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "#",
                                                    title: "Löschen",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openDeleteConfirmationModal(
                                                        data.item.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "inticon-autoclaim_loschen",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1349500176
                            ),
                          })
                        : _c(
                            "b-alert",
                            { attrs: { show: "", variant: "info" } },
                            [
                              _vm._v(
                                "\n                    Keine firmenspezifischen Dokumente vorhanden.\n                "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        "cancel-title": "Abbrechen",
                        title: "Dokument löschen",
                      },
                      on: {
                        hidden: _vm.resetDeleteId,
                        ok: _vm.deleteFirmSpecificDocument,
                      },
                      model: {
                        value: _vm.isDeleteConfirmationModalOpen,
                        callback: function ($$v) {
                          _vm.isDeleteConfirmationModalOpen = $$v
                        },
                        expression: "isDeleteConfirmationModalOpen",
                      },
                    },
                    [
                      _vm._v(
                        "\n                Wollen Sie das Dokument wirklich löschen?\n            "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }